import { LibraryExercise } from '../library/exercises/types';
import { sortByOrder } from '@strength/utils';
import { BenchmarkGrid } from '@strength/domain';

export type CoreExercise = { sortOrder: number } & LibraryExercise;

export function hydrateCoreExercises(
  coreExercises: BenchmarkGrid['coreExercises'],
  exercises: LibraryExercise[],
): CoreExercise[] {
  return sortByOrder(
    coreExercises.flatMap(({ libraryExerciseId, sortOrder }) => {
      const exercise = exercises.find(
        (exercise) => exercise.id === libraryExerciseId,
      );
      if (!exercise) {
        return [];
      }
      return {
        ...exercise,
        sortOrder,
      };
    }),
  );
}

export const getAgeFromBirthdate = (birthdate: string): number => {
  const birthdateDate = new Date(birthdate);
  const ageDiffMs = Date.now() - birthdateDate.getTime();
  const ageDate = new Date(ageDiffMs);
  return Math.abs(ageDate.getUTCFullYear() - 1970);
};
